import { render, staticRenderFns } from "./AddAreaDialog.vue?vue&type=template&id=2aedbcbc&"
import script from "./AddAreaDialog.vue?vue&type=script&lang=js&"
export * from "./AddAreaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports